import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoNnh: CultureInfo = {
  name: 'nnh',
  displayName: 'Shwóŋò ngiembɔɔn',
  iso3LanguageCode: 'nnh',
  iso2LanguageCode: 'nnh',
  ietfLanguageTag: 'nnh',
  parent: null
};
